import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import noop from 'lodash/noop';
import PriceRangeFilter from 'components/Filters/Search/PriceFilter/PriceRangeFilter';
import { getMinAvailablePointsPrice, getMaxAvailablePointsPrice } from 'store/search/searchSelectors';
import formatNumber from 'lib/formatters/formatNumber';
import { getQueryMaxPrice, getQueryMinPrice } from 'store/router/routerSelectors';

const STEP_INCREMENT = 1000;
const UPPER_PRICE_LIMIT = 120000;
const formatPrice = (price) => `${formatNumber({ number: price })} PTS`;

const PointsPriceRangeFilter = ({ onChange, updatePriceRangeLabels }) => {
  const minAvailablePrice = useSelector(getMinAvailablePointsPrice);
  const maxAvailablePrice = useSelector(getMaxAvailablePointsPrice);
  const minPrice = useSelector(getQueryMinPrice);
  const maxPrice = useSelector(getQueryMaxPrice);

  return (
    <PriceRangeFilter
      currency="PTS"
      minAvailablePrice={minAvailablePrice}
      maxAvailablePrice={maxAvailablePrice}
      minPrice={minPrice}
      maxPrice={maxPrice}
      minPriceLabelValue={minPrice}
      maxPriceLabelValue={maxPrice}
      onChange={onChange}
      updatePriceRangeLabels={updatePriceRangeLabels}
      stepIncrement={STEP_INCREMENT}
      upperPriceLimit={UPPER_PRICE_LIMIT}
      formatPrice={formatPrice}
    />
  );
};

PointsPriceRangeFilter.propTypes = {
  onChange: PropTypes.func,
  updatePriceRangeLabels: PropTypes.func,
};

PointsPriceRangeFilter.defaultProps = {
  onChange: noop,
  updatePriceRangeLabels: noop,
};

export default PointsPriceRangeFilter;
